import { Component, EventEmitter, Output } from '@angular/core';
import { FlightConfigurationURL } from '../../constants/url/flightConfiguration.url';
import { HttpService } from '../../service/http/http.service';
import { FlightConfigurationDto } from '../../dto/flightConfiguration/flightConfiguration.dto';
import { DroneSpecificationDto } from 'src/app/dto/droneSpecification/droneSpecification.dto';
import { ResponseDto } from 'src/app/dto/common/response.dto';
import { AccountService } from 'src/app/service/account/account.service';
import { UnitDto } from 'src/app/dto/unit/unit.dto';
import { DroneCode } from 'src/app/dto/droneSpecification/droneSpec.code';

@Component({
    selector: 'flightConfig',
    templateUrl: '../../view/flightConfiguration/flightConfiguration.html'
})
export class FlightConfiguraitonComponent {
    public flightConfigurationDto!: FlightConfigurationDto;
    public droneSpecification!: DroneSpecificationDto;
    public calculatedFlightConfigurationDto!: FlightConfigurationDto;
    public userUnit: UnitDto = new UnitDto();

    public droneCode: typeof DroneCode = DroneCode;

    @Output() getChangeFlightConfigEvent = new EventEmitter<FlightConfigurationDto>();

    constructor(private httpService: HttpService, private accountService: AccountService) {}

    public getFlightConfigratuion(): void {
        this.httpService.get<ResponseDto<FlightConfigurationDto>>(FlightConfigurationURL.userFlightConfiguration(this.accountService.getAccountSeq()))
            .subscribe(response => {
                if (response.isSuccess) {
                    this.flightConfigurationDto = Object.assign(new FlightConfigurationDto(), response.data);
                    this.calculatedFlightConfigurationDto = Object.assign(new FlightConfigurationDto(), response.data);
                    this.getChangeFlightConfigEvent.emit(this.flightConfigurationDto);

                    this.calculateValue();
                }
            });
    }

    public setDroneSpecifitiaon(droneSpecifationDto: DroneSpecificationDto): void {
        this.droneSpecification = Object.assign(new DroneSpecificationDto(), droneSpecifationDto);
        this.calculatedFlightConfigurationDto.droneSpecSeq = this.droneSpecification.seq;
        this.calculatedFlightConfigurationDto.name = this.droneSpecification.name;
        //this.calculatedFlightConfigurationDto.setDroneSpecificationDtoInfo(droneSpecifationDto);
        this.changeConfiguration();
    }

    public changeConfiguration(): void {
        this.setOriginDtoValue();
        this.flightConfigurationDto.accountSeq = this.accountService.getAccountSeq();

        this.httpService.post<ResponseDto<Boolean>>(FlightConfigurationURL.addFlightConfiguration, this.flightConfigurationDto)
            .subscribe(response => {
                if (response.isSuccess) {
                    this.getChangeFlightConfigEvent.emit(this.flightConfigurationDto);
                }
            })
    }

    public setUserUnit(unitDto: UnitDto): void {
        this.userUnit = Object.assign(new UnitDto(), unitDto);
        this.calculateValue();
    }

    private calculateValue(): void {
        this.calculatedFlightConfigurationDto = Object.assign(new FlightConfigurationDto(), this.getFlightConfigurationDto());
        this.calculatedFlightConfigurationDto.setValuesAtUserUnit(this.userUnit);
    }

    private setOriginDtoValue(): void {
        this.flightConfigurationDto = Object.assign(new FlightConfigurationDto(), this.calculatedFlightConfigurationDto);
        this.flightConfigurationDto.setValuesAtDefaultUnit(this.userUnit);
    }

    private getFlightConfigurationDto(): FlightConfigurationDto {
        if (this.flightConfigurationDto) {
            return this.flightConfigurationDto;
        }

        return this.getDefaultFlightConfigurationDto();
    }

    private getDefaultFlightConfigurationDto(): FlightConfigurationDto {
        let defaultDto: FlightConfigurationDto = new FlightConfigurationDto();

        defaultDto.accountSeq = this.accountService.getAccountSeq();
        defaultDto.minimumTemperature = 0;
        defaultDto.maximumTemperature = 35;
        defaultDto.windResistance = 7;
        defaultDto.satelliteCount = 9;
        defaultDto.maximumHumidity = 90;
        defaultDto.cloudCover = 80;
        defaultDto.visibility = 8000;
        defaultDto.precipitation = 70;

        return defaultDto;
    }
}
